type ReviewWarningPattern = {
  keyword: string;
  regex: RegExp;
};

const REVIEW_WARNING_PATTERNS: ReviewWarningPattern[] = [
  { keyword: "google", regex: /\bgoogle\b/ },
  { keyword: "yelp", regex: /\byelp\b/ },
  { keyword: "tripadvisor", regex: /\btrip\s*advisor\b|\btripadvisor\b/ },
  {
    keyword: "give us 5 stars",
    regex: /\bgive\s+us\s+(?:5|five)\s+stars?\b/,
  },
  {
    keyword: "5-star",
    regex: /\b(?:5\s*-\s*stars?|5\s+stars?|five\s+stars?)\b/,
  },
  { keyword: "rating", regex: /\bratings?\b/ },
  { keyword: "review", regex: /\breviews?\b/ },
];

const normalizeTextForDetection = (value: string): string => {
  return value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[–—−]/g, "-");
};

export const detectIncentivizedReviewKeyword = (
  value?: string | null,
): string | null => {
  if (!value) return null;

  const normalizedText = normalizeTextForDetection(value);
  const matchedPattern = REVIEW_WARNING_PATTERNS.find(({ regex }) =>
    regex.test(normalizedText),
  );

  return matchedPattern?.keyword ?? null;
};
